module.exports = __webpack_public_path__ + "static/media/afflixbg.04909612.png";